module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "nav"
    }
  }, [_c('div', {
    staticClass: "topBar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "moduleTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.moduleTitle)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v(_vm._s(_vm.subhead))])]), _vm._v(" "), _c('div', {
    staticClass: "moduleNav"
  }, [_c('md-list', {
    staticClass: "nav"
  }, [_c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-1"
    }
  }, [_c('div', {
    staticClass: "imgWrap",
    class: {
      active: _vm.activeId == '1'
    },
    on: {
      "click": function($event) {
        _vm.moduleSelected(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/1.svg"),
      "alt": "Module 1"
    }
  })])])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-2"
    }
  }, [_c('div', {
    staticClass: "imgWrap",
    class: {
      active: _vm.activeId == '2'
    },
    on: {
      "click": function($event) {
        _vm.moduleSelected(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/2.svg"),
      "alt": "Module 2"
    }
  })])])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-3"
    }
  }, [_c('div', {
    staticClass: "imgWrap",
    class: {
      active: _vm.activeId == '3'
    },
    on: {
      "click": function($event) {
        _vm.moduleSelected(3)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/3.svg"),
      "alt": "Module 3"
    }
  })])])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-4"
    }
  }, [_c('div', {
    staticClass: "imgWrap",
    class: {
      active: _vm.activeId == '4'
    },
    on: {
      "click": function($event) {
        _vm.moduleSelected(4)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/4.svg"),
      "alt": "Module 4"
    }
  })])])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-5"
    }
  }, [_c('div', {
    staticClass: "imgWrap",
    class: {
      active: _vm.activeId == '5'
    },
    on: {
      "click": function($event) {
        _vm.moduleSelected(5)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/5.svg"),
      "alt": "Module 5"
    }
  })])])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-6"
    }
  }, [_c('div', {
    staticClass: "imgWrap",
    class: {
      active: _vm.activeId == '6'
    },
    on: {
      "click": function($event) {
        _vm.moduleSelected(6)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/6.svg"),
      "alt": "Module 1"
    }
  })])])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    attrs: {
      "to": "/module-7"
    }
  }, [_c('div', {
    staticClass: "imgWrap",
    class: {
      active: _vm.activeId == '7'
    },
    on: {
      "click": function($event) {
        _vm.moduleSelected(7)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/7.svg"),
      "alt": "Module 7"
    }
  })])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "phone-viewport"
  }, [_c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    on: {
      "open": function($event) {
        _vm.open('Left')
      },
      "close": function($event) {
        _vm.close('Left')
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-large"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-disabled",
    nativeOn: {
      "click": function($event) {
        _vm.toggleLeftSidenav($event)
      }
    }
  }, [(_vm.menuHidden) ? _c('img', {
    attrs: {
      "src": require("../assets/menu.svg"),
      "alt": "Menu"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/close.svg"),
      "alt": "Close Menu"
    }
  })])], 1), _vm._v(" "), _c('md-list', {
    staticClass: "nav"
  }, [_c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    attrs: {
      "to": "/front"
    },
    nativeOn: {
      "click": [function($event) {
        _vm.moduleSelected(0)
      }, function($event) {
        _vm.toggleLeftSidenav($event)
      }]
    }
  }, [_c('p', [_vm._v("Course content")])])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    class: {
      active: _vm.activeId == '1'
    },
    attrs: {
      "to": "/module-1"
    },
    nativeOn: {
      "click": [function($event) {
        _vm.moduleSelected(1)
      }, function($event) {
        _vm.toggleLeftSidenav($event)
      }]
    }
  }, [_c('p', [_vm._v("Module 1")]), _c('span', [_vm._v("Features")]), _c('img', {
    class: {
      completed: _vm.modules[1].complete === true
    },
    attrs: {
      "src": require("../assets/tick.svg"),
      "alt": "Module 1 Complete"
    }
  })])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    class: {
      active: _vm.activeId == '2'
    },
    attrs: {
      "to": "/module-2"
    },
    nativeOn: {
      "click": [function($event) {
        _vm.moduleSelected(2)
      }, function($event) {
        _vm.toggleLeftSidenav($event)
      }]
    }
  }, [_c('p', [_vm._v("Module 2")]), _c('span', [_vm._v("Modes of operation")]), _c('img', {
    class: {
      completed: _vm.modules[2].complete === true
    },
    attrs: {
      "src": require("../assets/tick.svg"),
      "alt": "Module 2 Complete"
    }
  })])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    class: {
      active: _vm.activeId == '3'
    },
    attrs: {
      "to": "/module-3"
    },
    nativeOn: {
      "click": [function($event) {
        _vm.moduleSelected(3)
      }, function($event) {
        _vm.toggleLeftSidenav($event)
      }]
    }
  }, [_c('p', [_vm._v("Module 3")]), _c('span', [_vm._v("Alarms & Trouble Shooting")]), _c('img', {
    class: {
      completed: _vm.modules[3].complete === true
    },
    attrs: {
      "src": require("../assets/tick.svg"),
      "alt": "Module 3 Complete"
    }
  })])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    class: {
      active: _vm.activeId == '4'
    },
    attrs: {
      "to": "/module-4"
    },
    nativeOn: {
      "click": [function($event) {
        _vm.moduleSelected(4)
      }, function($event) {
        _vm.toggleLeftSidenav($event)
      }]
    }
  }, [_c('p', [_vm._v("Module 4")]), _c('span', [_vm._v("Care & Maintenance")]), _c('img', {
    class: {
      completed: _vm.modules[4].complete === true
    },
    attrs: {
      "src": require("../assets/tick.svg"),
      "alt": "Module 4 Complete"
    }
  })])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    class: {
      active: _vm.activeId == '5'
    },
    attrs: {
      "to": "/module-5"
    },
    nativeOn: {
      "click": [function($event) {
        _vm.moduleSelected(5)
      }, function($event) {
        _vm.toggleLeftSidenav($event)
      }]
    }
  }, [_c('p', [_vm._v("Module 5")]), _c('span', [_vm._v("Accessories")]), _c('img', {
    class: {
      completed: _vm.modules[5].complete === true
    },
    attrs: {
      "src": require("../assets/tick.svg"),
      "alt": "Module 5 Complete"
    }
  })])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    class: {
      active: _vm.activeId == '6'
    },
    attrs: {
      "to": "/module-6"
    },
    nativeOn: {
      "click": [function($event) {
        _vm.moduleSelected(6)
      }, function($event) {
        _vm.toggleLeftSidenav($event)
      }]
    }
  }, [_c('p', [_vm._v("Module 6")]), _c('span', [_vm._v("Additional Features")]), _c('img', {
    class: {
      completed: _vm.modules[6].complete === true
    },
    attrs: {
      "src": require("../assets/tick.svg"),
      "alt": "Module 6 Complete"
    }
  })])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-accent"
  }, [_c('router-link', {
    class: {
      active: _vm.activeId == '7'
    },
    attrs: {
      "to": "/module-7"
    },
    nativeOn: {
      "click": [function($event) {
        _vm.moduleSelected(7)
      }, function($event) {
        _vm.toggleLeftSidenav($event)
      }]
    }
  }, [_c('p', [_vm._v("Module 7")]), _c('span', [_vm._v("Course Summary & Assessment")]), _c('img', {
    class: {
      completed: _vm.modules[7].complete === true
    },
    attrs: {
      "src": require("../assets/tick.svg"),
      "alt": "Module 7 Complete"
    }
  })])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a62a603a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigator.vue
// module id = 761
// module chunks = 0